module.exports = __webpack_public_path__ + "img/register-right-2.50afd0e3.svg";